// Header js start


// Header js end


// //Collection page grid style js
// document.addEventListener('DOMContentLoaded', ()=>{
//   console.log('11111111111112222222222222222222333333333333333333333334444444444444444444444');
//         var productGrid = document.querySelector('#product-grid');
//   console.log(productGrid)
//         if(productGrid){
//             var products = document.querySelectorAll('.grid__item.product-item');
//             var count = products.length;
        
//             // Reset all product cards to default width
//             products.forEach(product => {
//               product.style.gridColumn = 'span 1';
//             });
        
//             if (count % 4 === 0) {
//               // If divisible by 4, keep all at 25%
//               productGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
//               console.log('aaaaaaaa')
//             } else if (count % 4 === 1) {
//               // Last 3 at 25%
//               productGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
//               console.log('bbbbbbbbbb')
//               for (let i = count - 3; i < count; i++) {
//                 products[i].style.gridColumn = 'span 1';
//                 products[count - 1].style.gridColumn = '2/4';
//               }
//             } else if (count % 4 === 2) {
//               // Last 2 at 50%
//               productGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
//               console.log('ccccccccc')
//               for (let i = count - 2; i < count; i++) {
//                 products[i].style.gridColumn = 'span 2';
//               }
//             } else if (count % 4 === 3) {
//               // Last 1 at 50%
//               productGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
//               console.log('dddddddddddddddd')
//               // products[count - 1].style.gridColumn = 'span 2';
//             }
//         }
        
// })

const GP_PREV_ARROW = `<button class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="arrow-left-line"><path id="Vector" d="M7.828 10.9997H20V12.9997H7.828L13.192 18.3637L11.778 19.7777L4 11.9997L11.778 4.22168L13.192 5.63568L7.828 10.9997Z" fill="#19141F"/></g></svg></button>`;
const GP_NEXT_ARROW = `<button class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="arrow-right-line"><path id="Vector" d="M16.172 10.9997H4V12.9997H16.172L10.808 18.3637L12.222 19.7777L20 11.9997L12.222 4.22168L10.808 5.63568L16.172 10.9997Z" fill="#19141F"/></g></svg></button>`;

// featured collection slick slider start
$(document).ready(function () {
	// Initialize slick slider
	$('.custom-product-slider').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '200px',
		arrows: true,
		initialSlide: 1,
		prevArrow: GP_PREV_ARROW,
		nextArrow: GP_NEXT_ARROW,
		responsive: [{
			breakpoint: 1250,
			settings: {
				slidesToShow: 2,
				centerMode: true,
				centerPadding: '15%',
				slidesToScroll: 1,
				infinite: true,
				dots: false
			}
		},{
			breakpoint: 600,
			settings: {
				centerMode: true,
				centerPadding: '20%',
				slidesToShow: 1,
				slidesToScroll: 1
			}
		},],
	});
	//to handle cards with recharge injection targets:
	$('.custom-product-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
		if(typeof GPInjectRecharge !== 'undefined'){
			GPInjectRecharge();
		}
	});
	
	//the crappy yotpo app doesn't allow us to add a custom link to the reviews widget, so this hack:
	const yotpo_widgets = document.querySelectorAll('[id*="yotpo_product_reviews_star_rating"]');
	yotpo_widgets.forEach(function(element, index, array){
		let a = document.createElement('a');
		a.setAttribute('href', '/pages/reviews');
		//insert the new node before the target node:
		element.before(a);
		//move widget into the link:
		a.appendChild(element);
	});

    // Ensure the DOM is ready before applying the change event
    setTimeout(function () {
        $('.select-product-variants').on('change', function () {
            var val = $(this).val();

            // Ensure the closest form and product-variant-id exist
            var form = $(this).closest('.card__content').find('form');
            var variantInput = form.find('.product-variant-id');

            if (form.length && variantInput.length) {
                variantInput.val(val);
            } else {
                console.error("Form or product-variant-id input not found.");
            }
        });
    }, 1000);
});
// featured collection slick slider end

$('.reviews_slider').slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	initialSlide: 2,
	// autoplay: true,
	// autoplaySpeed: 2000,
	dots: false,
	centerMode:true,
	centerPadding: '25px',
	arrows: true,
	prevArrow: GP_PREV_ARROW,
	nextArrow: GP_NEXT_ARROW,
	responsive: [{
		breakpoint: 1301,
		settings: {
			slidesToShow: 3,
			centerMode:true,
			centerPadding: '40px',
			slidesToScroll: 1
		}
	},{
		breakpoint: 1024,
		settings: {
			slidesToShow: 2,
			centerMode:true,
			centerPadding: '40px',
			slidesToScroll: 1
		}
	},{
	breakpoint: 880,
	settings: {
			slidesToShow: 1,
			centerMode:true,
			centerPadding: '40px',
			slidesToScroll: 1
		}
	},]
});
	
$('.custom-blog-slider').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	dots: false,
	arrows: false,
	arrows: true,
	prevArrow: GP_PREV_ARROW,
	nextArrow: GP_NEXT_ARROW,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 525,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});
$('.read-more-blog-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
        {
            breakpoint: 525,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
});

//Product Page
// $(document).ready(function(){
//   // Initialize Slick Slider for the product images
//   $('.product-slider').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     fade: true,
//     asNavFor: '.product-thumbs'
//   });

//   // Initialize Slick Slider for the vertical thumbnails
//   $('.product-thumbs').slick({
//     slidesToShow: 6,
//     slidesToScroll: 1,
//     asNavFor: '.product-slider',
//     dots: false,
//     arrows: true,
//     focusOnSelect: true,
//     vertical: true,
//     infinite:false
//   });  
// });

$(document).ready(function(){
  // Initialize Slick Slider for the product images
  $('.product-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.product-thumbs',
     responsive: [
        
        {
            breakpoint: 560,
            settings: {
                dots: true,
              centerMode: true,
        centerPadding: '50px',
               arrows: false,
            }
        }
    ]
  });

  // Initialize Slick Slider for the vertical thumbnails
  $('.product-thumbs').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.product-slider',
    dots: false,
    arrows: true,
    focusOnSelect: true,
    vertical: true,
    infinite: false
  });



  // Handle opening the modal and syncing the slider
  $('.product-slider').on('click', '.slick-slide', function() {

      // Initialize the modal slider (with the same images as the main slider)
      $('.modal-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
      });
    
    var currentSlide = $(this).attr('data-slick-index');
    $('.modal-slider').slick('slickGoTo', currentSlide); // Sync modal slider with the current slide
    $('#productModal').fadeIn(); // Open the modal
  });

  // Handle closing the modal
  $('.close').click(function() {
    $('#productModal').fadeOut(); // Close the modal
     $('.modal-slider').slick("unslick");
  });

  // Handle clicking outside the modal to close it
  $(window).click(function(event) {
    if ($(event.target).is('#productModal')) {
      $('#productModal').fadeOut(); // Close modal when clicking outside the modal content
      $('.modal-slider').slick("unslick");
    }
  });
});

// $(document).ready(function(){
//   // Initialize Slick Slider for the product images (Main slider)
//   $('.product-slider').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: true,
//     fade: true,
//     asNavFor: '.product-thumbs'
//   });

//   // Initialize Slick Slider for the vertical thumbnails
//   $('.product-thumbs').slick({
//     slidesToShow: 6,
//     slidesToScroll: 1,
//     asNavFor: '.product-slider',
//     dots: false,
//     arrows: true,
//     focusOnSelect: true,
//     vertical: true,
//     infinite: false
//   });

//   // Flag to check if the modal slider is initialized
//   var modalSliderInitialized = false;

//   // Handle opening the modal and initializing the slider
//   $('.product-slider').on('click', '.slick-slide img', function() {
//     var currentSlide = $(this).parent().attr('data-slick-index'); // Get the current slide index

//     if (!modalSliderInitialized) {
//       // Initialize the modal slider only when clicked for the first time
//       $('.modal-slider').slick({
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         arrows: true,
//         fade: true,
//       });
//       modalSliderInitialized = true; // Set the flag to true
//     }

//     // Go to the current clicked slide in the modal slider
//     $('.modal-slider').slick('slickGoTo', currentSlide); 
//     $('#productModal').fadeIn(); // Open the modal
//   });

//   // Handle closing the modal and destroying the slider
//   $('.close').click(function() {
//     $('#productModal').fadeOut(); // Close the modal

//     // Destroy the modal slider to reset it
//     if (modalSliderInitialized) {
//       $('.modal-slider').slick('unslick'); // Destroy the modal slider
//       modalSliderInitialized = false; // Reset the flag for future clicks
//     }
//   });

//   // Handle clicking outside the modal to close it
//   $(window).click(function(event) {
//     if ($(event.target).is('#productModal')) {
//       $('#productModal').fadeOut(); // Close modal when clicking outside the modal content

//       // Destroy the modal slider to reset it
//       if (modalSliderInitialized) {
//         $('.modal-slider').slick('unslick'); // Destroy the modal slider
//         modalSliderInitialized = false; // Reset the flag for future clicks
//       }
//     }
//   });
// });
$(document).ready(function() {
  $('.tab-heading').click(function() {
    $('.tab-heading').removeClass('active');
    $('.tab-content').removeClass('active');
    $(this).addClass('active');
    var tabId = $(this).data('tab');
    $('#' + tabId).addClass('active');
  });
});
 $('.reviews_slider_2 ').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                dots: false,
                arrows: false,
                responsive: [
                   {
                        breakpoint: 1301,
                        settings: {
                            slidesToShow: 3,
                           centerMode:true,
                centerPadding: '40px',
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            centerMode:true,
                centerPadding: '40px',
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 880,
                        settings: {
                            slidesToShow: 1,
                            centerMode:true,
                centerPadding: '40px',
                            slidesToScroll: 1
                        }
                    },
                ]
            });
$(document).ready(function() {
  // Add 'active' class to the first FAQ item and show its content
  $('.faq-item').first().addClass('active').find('.faq-item-content').slideDown();

  $('.faq-item-summary').on('click', function() {
    // Get the parent FAQ item of the clicked summary
    const $item = $(this).parent('.faq-item');
    
    // Check if the clicked item is already active
    if ($item.hasClass('active')) {
      // If active, remove 'active' class and slide up its content
      $item.removeClass('active').find('.faq-item-content').slideUp();
    } else {
      // Remove 'active' from all items, slide up all contents
      $('.faq-item').removeClass('active').find('.faq-item-content').slideUp();
      
      // Add 'active' class to the clicked item and slide down its content
      $item.addClass('active').find('.faq-item-content').slideToggle();
    } 
  });

	$('.open-contact-form').click(function () {
		$('body').addClass('overflow-hidden');
		$('.contact-modal-area').addClass('popup-active');
	});
		
	$('.close-icon-modal, .outside-click').click(function () {
		$('body').removeClass('overflow-hidden');
		$('.contact-modal-area').removeClass('popup-active');
	});

	// Social Share URLs
	const pageUrl = window.location.href;
	const pageTitle = document.title;
	const share_links = [
		{id:'facebook-share', href:`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`},
		{id:'twitter-share', href:`https://twitter.com/intent/tweet?text=${encodeURIComponent(pageTitle)}&url=${encodeURIComponent(pageUrl)}`},
		{id:'pinterest-share', href:`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(pageUrl)}&description=${encodeURIComponent(pageTitle)}`},
		{id:'instagram-share', href:`https://www.instagram.com/`},// Instagram doesn't have a share URL.
		{id:'tiktok-share', href:`https://www.tiktok.com/`},// Tiktok doesn't have a share URL.
	];
	share_links.forEach(share_link => {
		const element = document.getElementById(share_link.id);
		if(element){
			element.href = share_link.href;
		}
	});
});
document.querySelectorAll('.reci-filter-header').forEach(function(recfil) {
    recfil.addEventListener('click', function() {
        // Toggle 'active-filter' class on the closest or specific target
        const filterCategory = recfil.closest('.filter-category'); // Adjust selector if needed
        if (filterCategory) {
            filterCategory.classList.toggle('active-filter');
        }
    });
});

// Copy Link Functionality
// document.querySelector('.copy-link').addEventListener('click', () => {
//   navigator.clipboard.writeText(pageUrl).then(() => {
//     alert('Link copied to clipboard!');
//   }).catch(err => {
//     console.error('Failed to copy link: ', err);
//   });
// });

const copy_link = document.querySelector('.copy-link');
if(copy_link){
	document.querySelector('.copy-link').addEventListener('click', () => {
	  const pageUrl = window.location.href; // Assuming 'pageUrl' is the current page URL
	  navigator.clipboard.writeText(pageUrl).then(() => {
		 // Create or select the message container
		 let message = document.querySelector('.copied-mess-btn button');
		 if (!message) {
			message = document.createElement('div');
			message.className = 'copied-mess-btn button';
			document.body.appendChild(message);
		 }
		 
		 // Set the message content and styles
		 message.textContent = 'Link copied';
		 message.style.position = 'fixed';
		 message.style.top = '30.5px';
		 message.style.left = '50%';
		 message.style.transform = 'translateX(-50%)';
		 message.style.zIndex = '99';
		 message.style.opacity = '1';
		 message.style.cursor = 'not-allowed';
		 message.style.pointerEvents = 'none';
		 message.style.transition = 'opacity 0.5s ease';
	
		 // Hide the message after 2 seconds
		 setTimeout(() => {
			message.style.opacity = '0';
			setTimeout(() => {
			  if (message.parentElement) {
				 message.parentElement.removeChild(message);
			  }
			}, 500); // Allow time for the fade-out transition
		 }, 500);
	  }).catch(err => {
		 console.error('Failed to copy link: ', err);
	  });
	});
}


// privacy policy js start

// document.addEventListener("DOMContentLoaded", () => {
//     const links = document.querySelectorAll(".table-content-link a");
//     if (links.length > 0) {
//         links[0].classList.add("active");
//     }
//     links.forEach(link => {
//         link.addEventListener("click", function(event) {
//             event.preventDefault();
//             links.forEach(link => link.classList.remove("active"));
//             this.classList.add("active");
//             const targetId = this.getAttribute("href").substring(1);
//             const targetElement = document.getElementById(targetId);
//             if (targetElement) {
//                 targetElement.scrollIntoView({ behavior: "smooth" });
//             }
//         });
//     });
// });
// privacy policy js end

// Side cart popup js start

$(document).ready(function() {
  $('.cartpop-clse-icon, .cart-out-click').click(function(event){
    $('body').removeClass('overflow-hidden');
    $('.cartpop-modal-area').removeClass('cart-popup-active');
  });
});


// Side cart popup js end

function GPUpdateRechargeText(){
	//hack to fix typo hardcoded into the ReCharge widget:
	const interval = setInterval(function(){
		const rc_widget_dropdowns = document.querySelectorAll('select.rc_widget__option__plans__dropdown');

		if(rc_widget_dropdowns.length > 0){
			rc_widget_dropdowns.forEach(dropdown => {
				const options = Array.from(dropdown.options);
				options.forEach(option => {
					option.innerHTML = option.innerHTML.replace(/Week's/, 'Weeks');
				});
			});

			clearInterval(interval);
		}
	}, 100);
}

function trace(c){if(typeof(console)!=='undefined'){console.log(c);}}
